@let showMinimal = showMinimal$ | async;
@let viewDetailsContentItem = viewDetailsContentItem$ | async;
@let activeContentDetailsItem = contentDetailsGlobalStore.contentItem();
@let isViewDetailsButtonSelected =
  contentDetailsGlobalStore.drawerState().visible &&
  activeContentDetailsItem?.scope === 'view' &&
  activeContentDetailsItem?.id === viewDetailsContentItem?.id;
@let burgerMenuItems = burgerMenuItems$ | async;
@let breadcrumbItems = breadcrumbItems$ | async;
@let searchableMenuTopItems = searchableMenuTopItems$ | async;
@let searchableMenuAllItems = searchableMenuAllItems$ | async;
@let searchableMenuHasMore = searchableMenuHasMore$ | async;
@let searchableMenuAllItemsPageSize = searchableMenuAllItemsPageSize$ | async;
@let searchableMenuTopItemsLoading = searchableMenuTopItemsLoading$ | async;
@let searchableMenuAllItemsLoading = searchableMenuAllItemsLoading$ | async;
@let filepathShowMenu = filepathShowMenu$ | async;
@let filepathChevronTooltip = (filepathChevronTooltip$ | async) ?? undefined;
@let filepathChevronTooltipText =
  filepathChevronTooltip | translateDisplayText: 'text' | async;
@let searchableMenuActiveItemId =
  (searchableMenuActiveItemId$ | async) ?? undefined;
@let searchableMenuSearchPlaceholder =
  (searchableMenuSearchPlaceholder$ | async) ?? undefined;
@let searchableMenuSearchPlaceholderText =
  searchableMenuSearchPlaceholder | translateDisplayText: 'text' | async;
@let searchableMenuTopItemsTitle =
  (searchableMenuTopItemsTitle$ | async) ?? undefined;
@let searchableMenuTopItemsTitleText =
  searchableMenuTopItemsTitle | translateDisplayText: 'text' | async;
@let searchableMenuNoItemsText =
  (searchableMenuNoItemsText$ | async) ?? undefined;
@let searchableMenuNoItemsTextText =
  searchableMenuNoItemsText | translateDisplayText: 'text' | async;
@let searchableMenuFooterAction = searchableMenuFooterAction$ | async;
@let toolbarPrimaryButton = toolbarPrimaryButton$ | async;
@let toolbarSecondaryButton = toolbarSecondaryButton$ | async;
@let viewDetailsButtonIsLast =
  viewDetailsContentItem &&
  (!navigationToolbarSettings.showToolbarSecondaryButton ||
    !toolbarSecondaryButton) &&
  (!navigationToolbarSettings.showToolbarPrimaryButton ||
    !toolbarPrimaryButton);
@let paddingCondition =
  !viewDetailsButtonIsLast &&
  ((navigationToolbarSettings.showToolbarSecondaryButton &&
    toolbarSecondaryButton) ||
    (navigationToolbarSettings.showToolbarPrimaryButton &&
      toolbarPrimaryButton) ||
    !navigationToolbarSettings.showFilepath ||
    (!filepathShowMenu && !breadcrumbItems?.length));
@let bdLogoLastCheck =
  showMinimal ||
  ((!navigationToolbarSettings.showMenu ||
    !(burgerMenuItems && burgerMenuItems.length)) &&
    (!navigationToolbarSettings.showFilepath ||
      (!(breadcrumbItems && breadcrumbItems.length) && !filepathShowMenu)) &&
    !viewDetailsContentItem &&
    (!navigationToolbarSettings.showToolbarSecondaryButton ||
      !toolbarSecondaryButton) &&
    (!navigationToolbarSettings.showToolbarPrimaryButton ||
      !toolbarPrimaryButton));
@let filePathLastCheck =
  !viewDetailsContentItem &&
  (!navigationToolbarSettings.showToolbarSecondaryButton ||
    !toolbarSecondaryButton) &&
  (!navigationToolbarSettings.showToolbarPrimaryButton ||
    !toolbarPrimaryButton);

<div
  data-id="navigation-toolbar"
  class="flex items-center"
  bdNoScroll
  [class]="paddingCondition ? 'pr-2' : ''"
>
  @if (navigationToolbarSettings.showLogo) {
    <bd-logo [isLastToolbarItem]="bdLogoLastCheck" />
  }
  @if (!showMinimal) {
    @if (navigationToolbarSettings.showMenu) {
      @if (burgerMenuItems && burgerMenuItems.length) {
        <bd-menu
          data-id="burger-menu"
          [menuItems]="burgerMenuItems"
          (selectedMenuItem)="handleBurgerMenuItemClick($event)"
        />
      }
    }
    @if (navigationToolbarSettings.showFilepath) {
      <bd-filepath
        [breadcrumbItems]="breadcrumbItems ?? []"
        [isLastToolbarItem]="filePathLastCheck"
        [chevronVisible]="!!filepathShowMenu"
        [chevronTooltip]="filepathChevronTooltipText ?? undefined"
      >
        @if (filepathShowMenu) {
          <bd-searchable-menu
            [topItems]="searchableMenuTopItems ?? []"
            [allItems]="searchableMenuAllItems ?? []"
            [hasMore]="searchableMenuHasMore ?? false"
            [allItemsPageSize]="searchableMenuAllItemsPageSize ?? 1"
            [isTopItemsLoading]="searchableMenuTopItemsLoading ?? false"
            [isAllItemsLoading]="searchableMenuAllItemsLoading ?? false"
            [activeItemId]="searchableMenuActiveItemId"
            [searchPlaceholder]="searchableMenuSearchPlaceholderText ?? ''"
            [topItemsTitle]="searchableMenuTopItemsTitleText ?? undefined"
            [noItemsText]="searchableMenuNoItemsTextText ?? undefined"
            [footerAction]="searchableMenuFooterAction ?? undefined"
            (searchChange)="handleSearchableMenuSearchChange($event)"
            (loadMore)="handleSearchableMenuLoadMore()"
            (itemClick)="handleSearchableMenuItemClick($event)"
          />
        }
      </bd-filepath>
    }
    @if (viewDetailsContentItem) {
      <ng-container *transloco="let t; scope: 'featureModeler'">
        <p-button
          class="pl-2"
          data-id="navigation-toolbar-content-details-panel-toggle-button"
          [text]="true"
          styleClass="bd-toolbar-button {{
            isViewDetailsButtonSelected ? 'bd-selected' : ''
          }} {{ viewDetailsButtonIsLast ? 'bd-round-right' : '' }}"
          [pTooltip]="t('featureModeler.subMenu.viewDetails')"
          tooltipPosition="bottom"
          [showDelay]="500"
          (onClick)="toggleViewDetails(viewDetailsContentItem)"
        >
          <i class="ui-info"></i>
        </p-button>
      </ng-container>
    }
    @if (navigationToolbarSettings.showToolbarSecondaryButton) {
      @if (
        toolbarSecondaryButton ?? undefined | translateActionButton | async;
        as button
      ) {
        <p-button
          class="pl-2"
          data-id="navigation-toolbar-button-secondary"
          [bdActionButton]="button"
          (onClick)="button.onClick($event)"
          [pTooltip]="button.tooltip ?? ''"
          [tooltipDisabled]="!button.tooltip"
          tooltipPosition="bottom"
          [showDelay]="500"
        ></p-button>
      }
    }
    @if (navigationToolbarSettings.showToolbarPrimaryButton) {
      @if (
        toolbarPrimaryButton ?? undefined | translateActionButton | async;
        as button
      ) {
        <p-button
          class="pl-2"
          data-id="navigation-toolbar-button-primary"
          [bdActionButton]="button"
          (onClick)="button.onClick($event)"
          [pTooltip]="button.tooltip ?? ''"
          [tooltipDisabled]="!button.tooltip"
          tooltipPosition="bottom"
          [showDelay]="500"
        ></p-button>
      }
    }
  }
</div>
